import { render, staticRenderFns } from "./EditWarehouseDialog.vue?vue&type=template&id=8c37e400&"
import script from "./EditWarehouseDialog.vue?vue&type=script&lang=js&"
export * from "./EditWarehouseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports